<div class="row m-0 p-0">
  <div class="col-6 col-xs-12 col-md-3 col-xl-2 p-0 m-0 pe-3 pb-3">
    <chatbots-quick-card></chatbots-quick-card>
  </div>
  <div class="col-6 col-xs-12 col-md-3 col-xl-2 p-0 m-0 pe-3 pb-3">
    <sessions-quick-card></sessions-quick-card>
  </div>
  <div class="col-6 col-xs-12 col-md-3 col-xl-2 p-0 m-0 pe-3 pb-3">
    <templating-quick-card></templating-quick-card>
  </div>
  <div class="col-6 col-xs-12 col-md-3 col-xl-2 p-0 m-0 pe-3 pb-3"
       *requireClaims="{ type: 'system', value: true }">
    <tenants-quick-card></tenants-quick-card>
  </div>
  <div class="col-6 col-xs-12 col-md-3 col-xl-2 p-0 m-0 pe-3 pb-3"
       *requireClaims="{ type: 'system', value: true }">
    <users-quick-card></users-quick-card>
  </div>
</div>
